<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!tax">
      <span class="loader"></span>
    </span>
    <div v-if="tax" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        value="label"
      >
        <tab-pane title="label" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <tax-view-global
            :tax="tax"
            @onEditTax="editTax"
            @onDeleteTax="deleteTax"
          />
        </tab-pane>

        <tab-pane
          title="logs"
          id="999"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file"></i>
            {{ $t("COMMON.LOGS") }}
          </span>
          <tax-view-logs :tax="tax" />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { Tabs, TabPane } from "@/components";
import TaxViewLogs from "../partials/TaxViewLogs.vue";
import TaxViewGlobal from "../partials/TaxViewGlobal.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    TaxViewLogs,
    TaxViewGlobal,
  },

  props: {
    taxId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      tax: null,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("taxes/get", this.taxId);
        this.tax = this.$store.getters["taxes/tax"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
    editTax(tax) {
      this.$emit("onEditTax", tax);
    },
    deleteTax(tax) {
      this.$emit("onDeleteTax", tax);
    },
  },
};
</script>
